// extracted by mini-css-extract-plugin
module.exports = {"choice":"styles_choice__16lHh","label":"styles_label__3YH5e","widget":"styles_widget__1UHNO"};